var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',{on:{"click":function($event){_vm.disabled ? null : _vm.$emit('click', $event)}}},[(!_vm.disabled)?[(_vm.href)?[_c('a',{staticClass:"link-icon",class:{
          'link-icon_bold': _vm.bold,
          'link-icon_grey': _vm.grey,
          'link-icon_dark-blue': _vm.darkBlue
        },attrs:{"href":_vm.href,"target":_vm.target}},[(_vm.icon)?_c('icon',{attrs:{"name":_vm.icon,"width":"16","height":"16"}}):_vm._e(),_c('div',{staticClass:"link-icon__text"},[_vm._t("default")],2)],1)]:[_c('router-link',{staticClass:"link-icon",class:{
          'link-icon_bold': _vm.bold,
          'link-icon_grey': _vm.grey,
          'link-icon_dark-blue': _vm.darkBlue
        },attrs:{"to":_vm.to,"target":_vm.target}},[(_vm.icon)?_c('icon',{attrs:{"name":_vm.icon,"width":"16","height":"16"}}):_vm._e(),_c('div',{staticClass:"link-icon__text"},[_vm._t("default")],2)],1)]]:[_c('span',{staticClass:"link-icon link-icon_disabled",class:{
        'link-icon_bold': _vm.bold,
        'link-icon_grey': _vm.grey,
        'link-icon_dark-blue': _vm.darkBlue
      }},[(_vm.icon)?_c('icon',{attrs:{"name":_vm.icon,"width":"16","height":"16"}}):_vm._e(),_c('div',{staticClass:"link-icon__text"},[_vm._t("default")],2)],1)]],2)
}
var staticRenderFns = []

export { render, staticRenderFns }